import { useEffect, useState } from 'react'

const WRAP = {
  position: 'fixed',
  bottom: '14px',
  right: '14px',
  zIndex: 2000,
  pointerEvents: 'auto',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  gap: '6px',
  fontFamily: 'inherit',
}
const BTN = {
  padding: '8px 14px',
  border: '1px solid rgba(255,255,255,0.2)',
  borderRadius: '8px',
  background: 'rgba(37,99,235,0.9)',
  color: '#fff',
  fontSize: '13px',
  fontWeight: 600,
  cursor: 'pointer',
  pointerEvents: 'auto',
}
const BTN_CONNECTED = {
  ...BTN,
  background: 'rgba(22,163,74,0.5)',
  border: '1px solid rgba(74,222,128,0.4)',
  color: '#bbf7d0',
}
const STATUS = { fontSize: '11px', color: '#fca5a5', textAlign: 'right', maxWidth: '200px', pointerEvents: 'none' }
const POPUP = {
  background: 'rgba(10,10,25,0.97)',
  border: '1px solid rgba(255,255,255,0.12)',
  borderRadius: '10px',
  padding: '10px 14px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  minWidth: '190px',
  pointerEvents: 'auto',
}
const DISC = {
  padding: '6px 10px', border: 0, borderRadius: '6px',
  background: 'rgba(239,68,68,0.25)', color: '#fca5a5',
  fontSize: '12px', cursor: 'pointer', pointerEvents: 'auto',
}

export function WalletConnect() {
  const [address, setAddress] = useState(null)
  const [status, setStatus] = useState('')
  const [busy, setBusy] = useState(false)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    try {
      const a = localStorage.getItem('wallet_address')
      if (a) setAddress(a)
    } catch (_) {}
  }, [])

  function handleClick(e) {
    e.stopPropagation()
    e.preventDefault()
    if (address) { setOpen(o => !o) } else { connect() }
  }

  async function connect() {
    if (busy) return
    setBusy(true)
    setStatus('Connecting...')
    try {
      const ethereum = window.ethereum
      if (!ethereum) {
        setStatus('No wallet found. Install MetaMask.')
        setBusy(false)
        return
      }
      const accounts = await ethereum.request({ method: 'eth_requestAccounts' })
      const addr = accounts[0]
      const message = 'Sign in to Hyperfy\n\nNonce: ' + Date.now()
      setStatus('Sign in your wallet...')
      const signature = await ethereum.request({ method: 'personal_sign', params: [message, addr] })
      setStatus('Authenticating...')
      const apiUrl = (typeof env !== 'undefined' && env.PUBLIC_API_URL) ? env.PUBLIC_API_URL : '/api'
      const res = await fetch(apiUrl + '/auth', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ address: addr, message, signature }),
      })
      const data = await res.json()
      if (!data.token) throw new Error(data.message || 'Auth failed')
      try { localStorage.setItem('wallet_token', data.token) } catch (_) {}
      try { localStorage.setItem('wallet_address', addr) } catch (_) {}
      setAddress(addr)
      setStatus('')
      setOpen(false)
      // Notify .hyp scripts (they listen for this event to set app.player.data.wallet)
      try {
        const ev = new CustomEvent('walletConnected', { detail: { wallet: addr } })
        document.body.dispatchEvent(ev)
        window.dispatchEvent(ev)
      } catch (_) {}
    } catch (e) {
      setStatus(e.message || 'Error')
    } finally {
      setBusy(false)
    }
  }

  function disconnect(e) {
    e.stopPropagation()
    try { localStorage.removeItem('wallet_token') } catch (_) {}
    try { localStorage.removeItem('wallet_address') } catch (_) {}
    setAddress(null)
    setStatus('')
    setOpen(false)
  }

  const short = address ? address.slice(0, 6) + '\u2026' + address.slice(-4) : null

  return (
    <div style={WRAP}>
      <button style={address ? BTN_CONNECTED : BTN} onClick={handleClick} disabled={busy}>
        {busy ? 'Connecting\u2026' : short || 'Connect Wallet'}
      </button>
      {status ? <div style={STATUS}>{status}</div> : null}
      {open && address ? (
        <div style={POPUP}>
          <div style={{ fontSize: '11px', color: '#94a3b8' }}>Connected</div>
          <div style={{ fontSize: '11px', color: '#e2e8f0', wordBreak: 'break-all', fontFamily: 'monospace' }}>{address}</div>
          <button style={DISC} onClick={disconnect}>Disconnect</button>
        </div>
      ) : null}
    </div>
  )
}
